import { Hub, BrowserClient } from '@sentry/browser';
import packageInfo from '../package.json.js';

const dsn = 'https://a30e35d12dce4437b0423ac5895b74c2@o354215.ingest.sentry.io/6020934';
let hub;
function initializeSentry(stage) {
    hub = new Hub(new BrowserClient({
        dsn,
        environment: stage,
        release: `header-account-flyout@${packageInfo.version}`,
    }));
}
function getSentryHub() {
    if (!hub) {
        initializeSentry('prod'); // fallback to prod
    }
    return hub;
}

export { getSentryHub, initializeSentry };
//# sourceMappingURL=sentryHub.js.map
